import { Component, computed, inject } from '@angular/core';
import { AppStore } from '../../../stores/app.store';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-no-facility-selected',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './no-facility-selected.component.html',
})
export class NoFacilitySelectedComponent {
  private readonly appStore = inject(AppStore);

  protected readonly hasOrganization = computed(
    () => !!this.appStore.selectedOrganizationId(),
  );

  protected readonly message = computed(() =>
    this.hasOrganization()
      ? 'Select a facility from the dropdown at the top of the page to continue.'
      : 'Select an organization and facility from the dropdown at the top of the page to continue.',
  );
}
